import { render, staticRenderFns } from "./QuatiFront.vue?vue&type=template&id=3c438ec6"
import script from "./QuatiFront.vue?vue&type=script&lang=js"
export * from "./QuatiFront.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports